import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarPedidos`, method: 'POST', body: value, token: token})
}
